import { inject, Injectable, Signal } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';

export type PageStatusValue = 'public' | 'guest' | 'hidden' | 'admin';

export interface PageStatusRecord {
  path: string;
  title: string;
  status: PageStatusValue;
}

export type PageStatusRow = PageStatusRecord & {
  path_slug: string | null;
  order: number;
  is_block_page: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class PageStatusService {
  private readonly http = inject(HttpClient);

  readonly pages = httpResource<PageStatusRow[]>(() => '/api/page-status', { defaultValue: [] });

  update(path: string, data: { title: string; status: PageStatusValue; order?: number }) {
    return this.http.patch<PageStatusRecord>(`/api/page-status/${encodeURIComponent(path)}`, data);
  }

  reset(doIt: Signal<boolean>) {
    return httpResource<PageStatusRecord[]>(() => (doIt() ? '/api/page-status/reset' : undefined), {
      defaultValue: [],
    });
  }
}
